import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';
import {ArticlesService} from '../services/articles.service';
import {ModalService} from '../shared/modal/modal.service';
import {FormAddArticleComponent} from '../shared/forms/form-add-article/form-add-article.component';
import {AddGalleryComponent} from '../shared/forms/add-gallery/add-gallery.component';
import {EditingService} from '../services/editing.service';
import {TitleServiceService} from '../services/title-service.service';
import {TitleFormComponent} from '../shared/forms/title-form/title-form.component';
import { AnimatedArticleRightComponent } from '../shared/animated-article-right/animated-article-right.component';
import { AnimatedArticleLeftComponent } from '../shared/animated-article-left/animated-article-left.component';
import { PageTitleComponent } from '../shared/page-title/page-title.component';
import { GalleryArticleComponent } from '../shared/gallery-article/gallery-article.component';


@Component({
    selector: 'app-rebuilds',
    templateUrl: './rebuilds.component.html',
    styleUrls: ['./rebuilds.component.scss'],
    imports: [PageTitleComponent, AnimatedArticleLeftComponent, AnimatedArticleRightComponent, GalleryArticleComponent, NgClass]
})
export class RebuildsComponent {
  private articleService = inject(ArticlesService);
  private modal = inject(ModalService);
  private editService = inject(EditingService);
  private titleService = inject(TitleServiceService);
  private destroyRef = inject(DestroyRef);

  readonly editMode = this.editService.editMode;
  /**
   * The articles to be used on the page.
   */
  articles: any[] = [];

  /**
   * sets the type of article for the page, so that the correct url is used.
   *
   * @type {string}
   */
  type = 'rebuilds';

  titleContent;

  constructor() {
    this.getArticles();
    this.getTitle();
  }

  /**
   * opens the modal for creating articles on the page
   * This is returned from the after close area of the modal.
   */
  onAddItem() {
    this.modal.open(FormAddArticleComponent, {data: {type: this.type, title: 'Create Article on page' + this.type, content:{}}})
        .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( response => {
      this.articleService.saveArticles(response);
      this.getArticles();
    });
  }

  onAddGallery() {
    this.modal.open(AddGalleryComponent, {data: {type: this.type, title: 'Create Article on page' + this.type, content: {}}})
        .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( response => {
      this.articleService.saveArticles(response);
      this.getArticles();
    });
  }

  onDeleted(id: string) {
    this.articles = this.articles.filter(article => article.id !== id);
  }

  /**
   * gets the articles for the french polishing pages
   */
  getArticles() {
    this.articleService.getArticles(this.type).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( data => {
      this.articles = data.sort((a, b) => (a.attributes.order || 0) - (b.attributes.order || 0));
    });
  }
  getTitle() {
    this.articleService.getTitle().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      const filteredTitle = data.filter((title) => title.attributes.page === this.type);
      this.titleContent = filteredTitle[0];
    });
  }
}
